import React from 'react';

import styles from './styles.module.css';

function GestorPosLicenseAgreement() {
	return (
		<section>
			<div className={styles.container}>
				<h1>Contrato de Licença de Usuário Final Brajan Sistemas</h1>
				<p>
					<b>Última atualização: 04/02/2026</b>
					<br></br>
					Este Contrato de Licença de Usuário Final ( Contrato ) é celebrado
					entre a empresa ou pessoa física que aceita este Contrato (sendo esta
					empresa ou pessoa física você/Comerciante ) e Brajan Sistemas (
					Desenvolvedor/Fornecedor do Aplicativo ). Este Contrato é celebrado
					exclusivamente entre você e o Desenvolvedor/Fornecedor do Aplicativo e
					rege o seu uso do aplicativo de software do Desenvolvedor e os
					serviços correspondentes que ele fornece (em conjunto, juntamente com
					a documentação, propriedade intelectual ou direitos autorais
					associados: o Aplicativo ). Leia este Contrato atentamente. Ao baixar,
					instalar, copiar ou usar o Aplicativo, você concorda em ficar
					vinculado aos termos deste Contrato e deve aceitá-lo antes de fazê-lo.
					Caso não concorde com os termos deste Contrato, você não deve baixar,
					instalar, copiar ou usar o Aplicativo.
				</p>
				<br />
				<h2>1. O aplicativo</h2>
				<p>
					1.1 O Aplicativo lhe proporcionará a capacidade de: fazer a maiorias
					das rotinas do sistema com relação ao gerenciamento de mesas e
					deliverys no modulo de restaurantes e gerenciamento de vendas no
					modulo de mini PDV.
				</p>
				<br />
				<p>
					1.2 O Desenvolvedor concede a você uma licença limitada, não
					exclusiva, intransferível, não sublicenciável e revogável durante a
					Vigência (definida abaixo) deste Contrato para usar o Aplicativo
					exclusivamente para fins comerciais internos. Você não poderá
					distribuir, alugar, arrendar, hospedar, sublicenciar, transferir,
					vender, exportar, modificar, realizar engenharia reversa, descompilar,
					copiar, realizar benchmarks, criar trabalhos derivados ou tentar
					derivar o código-fonte do Aplicativo. Esta licença não lhe concede
					quaisquer direitos sobre as marcas registradas, marcas de serviço,
					logotipos, identidade visual, direitos autorais ou outros direitos de
					propriedade intelectual do Desenvolvedor (ou de terceiros), a menos
					que sejam fornecidos com o Aplicativo. O Desenvolvedor reserva para si
					(ou para terceiros aplicáveis) todos os direitos, títulos, interesses
					e licenças (expressos ou implícitos) relativos ao Aplicativo que não
					sejam especificamente concedidos a você sob este Contrato. Você deverá
					preservar e exibir quaisquer avisos de propriedade, marcas ou
					logotipos associados ao uso do Aplicativo.
				</p>
				<br />
				<p>
					1.3 O aplicativo pode ser atualizado automaticamente de tempos em
					tempos, e você poderá ser solicitado a aceitar essas atualizações para
					continuar usando o aplicativo. O desenvolvedor poderá realizar
					manutenções no aplicativo, o que poderá resultar em interrupções ou
					atrasos no serviço ocasionalmente. O desenvolvedor poderá não oferecer
					suporte a versões antigas do aplicativo. Você é o único responsável
					por obter todos os equipamentos e serviços (por exemplo, conexão com a
					Internet) necessários para acessar e usar o aplicativo.
				</p>
				<br />
				<h2>2. Prazo</h2>
				<p>
					Este Contrato entra em vigor quando você aceita ou, de alguma forma,
					baixa, instala, copia ou usa o Aplicativo; e continuará mensalmente
					até ser rescindido (este período de tempo é o Prazo do Contrato ).
				</p>
				<h2>3. Suspensão e Rescisão</h2>
				<p>
					3.1 O Desenvolvedor poderá suspender ou encerrar imediatamente o seu
					uso do Aplicativo se (1) você violar os termos deste Contrato; (2) o
					Desenvolvedor acreditar que o seu uso do Aplicativo pode prejudicar
					sua reputação ou direitos de propriedade intelectual; (3) o
					Desenvolvedor suspender ou rescindir seus contratos com terceiros
					envolvidos no fornecimento do Aplicativo; (4) você exceder o uso
					normal e razoável do Aplicativo; (5) você entrar em processo de
					falência ou insolvência; ou (6) você estiver usando o Aplicativo para
					qualquer finalidade fraudulenta, ilegal ou não autorizada, ou se
					envolver em conduta dolosa em relação ao uso do Aplicativo.
					<br></br>
					3.2 Você poderá rescindir este Contrato a qualquer momento e por
					qualquer motivo (sem justa causa) mediante desintalação do aplicativo.
					Sua rescisão entrará em vigor imediantamente.
				</p>
				<h2>4. Confidencialidade, Dados e Ideias</h2>
				<p>
					4.1 Nenhuma das partes divulgará informações não públicas sobre os
					negócios da outra, incluindo, sem limitação, os termos deste Contrato,
					especificações técnicas (relacionadas ao Aplicativo ou não), listas de
					clientes ou informações relativas a assuntos operacionais,
					estratégicos ou financeiros de uma das partes (em conjunto, "
					Informações Confidenciais "). As Informações Confidenciais não incluem
					informações que (1) sejam ou se tornem publicamente disponíveis (sem
					culpa do destinatário); (2) o destinatário possua legalmente antes de
					sua divulgação; (3) sejam desenvolvidas independentemente sem depender
					das Informações Confidenciais do divulgador; ou (4) sejam recebidas de
					terceiros que não sejam obrigados a mantê-las confidenciais. Cada uma
					das partes implementará e manterá salvaguardas razoáveis ​​para
					proteger as Informações Confidenciais da outra.
				</p>
				<p>
					4.2 Nenhuma das partes poderá divulgar as Informações Confidenciais da
					outra, exceto (1) aos nossos respectivos diretores, executivos,
					funcionários ou representantes que precisem conhecê-las para cumprir
					nossas obrigações sob este Contrato; (2) em resposta a uma intimação
					ou ordem judicial; ou (3) conforme exigido por lei, norma ou
					regulamento aplicável.
				</p>
				<p>
					4.3 O Desenvolvedor poderá usar dados ou informações obtidos por meio
					do Aplicativo para fornecer seus serviços, para pesquisa e
					desenvolvimento ou, de forma agregada e anonimizada, para fornecer
					serviços em geral; tudo sujeito às Leis aplicáveis ​(definidas
					abaixo). As informações que o Desenvolvedor coleta sobre você ou seus
					consumidores estão sujeitas à política de privacidade do
					Desenvolvedor, acessível em
					<a href="https://politicas-de-privacidade.vercel.app/GestorPosCloverPrivacy">
						política de privacidade.
					</a>
				</p>
				<p>
					4.4 Você poderá fornecer, ou o Desenvolvedor poderá convidá-lo a
					fornecer, comentários ou ideias sobre o Aplicativo (incluindo, sem
					limitação, melhorias para o mesmo) (em conjunto, Ideias ). Ao enviar
					quaisquer Ideias, você concorda que (1) elas não são Informações
					Confidenciais; (2) elas não estão sujeitas a quaisquer restrições de
					uso ou divulgação (expressas ou implícitas); (3) você não reivindica
					quaisquer direitos sobre elas; e (4) o Desenvolvedor não tem obrigação
					de notificá-lo ou compensá-lo em relação à sua divulgação ou uso. Você
					isenta o Desenvolvedor de toda e qualquer responsabilidade ou
					obrigação que possa surgir do recebimento, análise, divulgação ou uso
					de qualquer Ideia que você enviar.
				</p>
				<h2>5. Conta</h2>
				<p>
					Para usar o Aplicativo, você precisará criar uma conta junto ao
					Desenvolvedor. Você deverá nos fornecer informações precisas ao
					configurar sua conta e mantê-la atualizada. Você será responsável por
					implementar medidas de segurança para impedir o acesso, a divulgação,
					o uso ou a alteração não autorizados da sua conta (essas medidas podem
					incluir, entre outras, nomes de usuário, senhas, perguntas e respostas
					de segurança ou outras credenciais). Você deverá notificar o
					Desenvolvedor caso descubra uma violação de segurança envolvendo sua
					conta ou o Aplicativo. Você é responsável por qualquer acesso,
					divulgação, uso ou alteração não autorizados da sua conta, do
					Aplicativo ou de outras informações de transação que ocorram por meio
					dos seus sistemas ou da sua conta.
				</p>
				<h2>6. Alocação de Risco</h2>
				<p>
					6.1 O Aplicativo é fornecido a você "no estado em que se encontra" e
					"conforme disponível". É de sua exclusiva responsabilidade determinar
					se o Aplicativo atende às suas necessidades. O Desenvolvedor se isenta
					de todas as garantias (expressas ou implícitas) relacionadas à sua
					conta ou ao Aplicativo; incluindo, sem limitação, garantias de
					segurança, comercialização, adequação a uma finalidade específica, não
					violação de direitos, precisão e operação ininterrupta ou livre de
					erros. O Desenvolvedor não se responsabiliza por quaisquer
					divulgações, modificações, exclusões ou outros erros que surjam em
					conexão com o seu uso do Aplicativo devido à sua interação com outros
					aplicativos ou seus conteúdos.
				</p>
				<p>
					6.2 Você indenizará o Desenvolvedor, seus diretores, executivos,
					funcionários, agentes, subsidiárias e afiliadas contra quaisquer
					reivindicações de terceiros por perdas, danos, custos ou despesas
					(incluindo honorários advocatícios razoáveis) (em conjunto, " Perdas
					") que resultem do seu uso ou uso indevido do Aplicativo ou da sua
					violação deste Contrato. O desenvolvedor poderá assumir a defesa de
					quaisquer reivindicações de terceiros pelas quais você deverá
					indenizá-lo (às suas custas), e você deverá cooperar com a defesa
					dessas reivindicações. Você não poderá celebrar qualquer acordo com
					terceiros que envolva mais do que o pagamento de uma quantia em
					dinheiro sem o consentimento prévio e por escrito do desenvolvedor.
				</p>
				<p>
					6.3 Na medida permitida pela legislação aplicável, o desenvolvedor não
					será responsável perante você por quaisquer lucros cessantes, perda de
					receita ou de oportunidades de negócios, nem por quaisquer danos
					exemplares, punitivos, especiais, indiretos, incidentais ou
					consequenciais; independentemente de tais danos serem previsíveis ou
					de qualquer uma das partes ter sido avisada de sua possibilidade.
				</p>
				<p>
					6.4 A responsabilidade total e agregada do desenvolvedor perante você
					por todas as Perdas decorrentes de qualquer causa (independentemente
					da forma de ação ou teoria jurídica) em conexão com este Contrato não
					excederá o valor das taxas que você pagou ao desenvolvedor durante os
					3 meses anteriores à Perda.
				</p>
				<h2>7. Comunicações</h2>
				<p>
					Você autorizou o Desenvolvedor a se comunicar com você eletronicamente
					ou de outra forma, utilizando as informações de contato que você
					fornecer (por exemplo, sem limitação, por meio de sua conta, internet,
					e-mail, SMS ou ligações telefônicas automatizadas ou com atendente
					para seu celular ou outro telefone, mesmo que esses números estejam
					cadastrados em listas de bloqueio de chamadas). Você é responsável por
					quaisquer taxas cobradas por sua operadora de telefonia por
					comunicações telefônicas, SMS ou e-mails que o Desenvolvedor lhe
					enviar.
				</p>
				<h2>8. Conformidade com as leis de privacidade</h2>
				<p>
					O Fornecedor do Aplicativo assume os seguintes compromissos,
					declarações e garantias adicionais para você, Comerciante:
				</p>
				<p>
					8.1 O Fornecedor do Aplicativo processará os Dados do Comerciante e as
					Informações Pessoais somente em nome do Comerciante e como seu
					Prestador de Serviços, e não coletará, reterá, usará ou divulgará
					esses dados para qualquer finalidade que não seja o cumprimento das
					obrigações do Fornecedor do Aplicativo nos termos deste Contrato,
					conforme permitido pela CCPA e outras leis de privacidade e proteção
					de dados aplicáveis ​​(coletivamente, “Leis de Privacidade”). Em
					nenhuma hipótese o Fornecedor do Aplicativo “venderá” (conforme
					definido pelas Leis de Privacidade) quaisquer dessas informações
					pessoais.
				</p>
				<p>
					8.2 O Fornecedor do Aplicativo não coletará, usará, reterá, divulgará,
					venderá ou disponibilizará os Dados do Comerciante ou as Informações
					Pessoais para seus próprios fins comerciais ou de forma que não esteja
					em conformidade com a CCPA ou outras Leis de Privacidade.
				</p>
				<p>
					8.3 O Fornecedor do Aplicativo limitará a coleta, o uso, a retenção e
					a divulgação de informações pessoais às atividades razoavelmente
					necessárias e proporcionais para fornecer os Serviços estabelecidos no
					Contrato ou outra finalidade operacional compatível.
				</p>
				<h2>9. Direitos do titular dos dados - assistência com solicitações</h2>
				<p>
					9.1 O Fornecedor do Aplicativo cooperará e auxiliará o Comerciante de
					forma razoável no cumprimento de suas obrigações de conformidade com a
					CCPA e a legislação de privacidade, bem como responderá a consultas
					relacionadas à CCPA, incluindo o atendimento a solicitações
					verificáveis ​​do consumidor, levando em consideração a natureza do
					processamento realizado pelo Fornecedor do Aplicativo e as informações
					disponíveis para o Fornecedor do Aplicativo. O Fornecedor do
					Aplicativo disponibilizará ao Comerciante, de maneira consistente com
					a funcionalidade do Serviço e com seu papel como Provedor de
					Informações Pessoais dos titulares dos dados, a possibilidade de
					atender às solicitações dos titulares dos dados para exercerem seus
					direitos sob as leis de privacidade.
				</p>
				<p>
					9.2 Caso o Fornecedor do Aplicativo receba uma solicitação do titular
					dos dados do Comerciante para exercer um ou mais de seus direitos sob
					as leis de privacidade em relação aos Serviços, o Fornecedor do
					Aplicativo redirecionará o titular dos dados para que este faça sua
					solicitação diretamente ao Comerciante. O Comerciante será responsável
					por responder a qualquer solicitação desse tipo, inclusive, quando
					possível, utilizando a funcionalidade dos Serviços. O Fornecedor do
					Aplicativo atenderá às solicitações razoáveis ​​do Comerciante para
					auxiliá-lo na resposta a tal solicitação do titular dos dados.
				</p>
				<p>
					9.3 O Fornecedor do Aplicativo deve notificar o Comerciante
					imediatamente caso receba qualquer reclamação, notificação ou
					comunicação que esteja direta ou indiretamente relacionada ao
					cumprimento, por qualquer uma das partes, das Leis de Privacidade
					referentes à prestação dos Serviços.
				</p>
				<h2>10. Geral</h2>
				<p>
					10.1 Você declara e garante que tem autoridade para celebrar este
					Contrato, criando obrigações de desempenho legalmente exigíveis contra
					você.
				</p>
				<p>
					10.2 O Desenvolvedor poderá modificar este Contrato periodicamente e
					lhe notificará quando essas modificações ocorrerem (a notificação
					poderá ser feita por meio do Aplicativo, e-mail, website, alterações
					na data exibida na parte superior deste Contrato ou outros meios
					eletrônicos). Seu uso contínuo do Aplicativo indica sua aceitação de
					quaisquer modificações a este Contrato. Você deve interromper o uso e
					desinstalar o Aplicativo caso não concorde com quaisquer modificações
					feitas a este Contrato.
				</p>
				<p>
					10.3 Cada uma das partes cumprirá as leis, normas e regulamentos (em
					conjunto, "Leis ") aplicáveis ​​ao seu respectivo desempenho sob este
					Contrato; incluindo, sem limitação, leis relacionadas à coleta e ao
					uso de informações do consumidor obtidas por meio do Aplicativo. Você
					seguirá os requisitos de toda a documentação do usuário fornecida para
					o Aplicativo. Você não usará seu Aplicativo para acessar, armazenar ou
					transmitir materiais que sejam ilícitos, difamatórios ou ofensivos;
				</p>
				<p>
					10.4 Este é o acordo integral entre nós e substitui quaisquer acordos
					anteriores relacionados ao seu objeto. Quaisquer seções ou termos
					deste Contrato que sejam, ou se tornem, inválidos ou inexequíveis
					serão considerados nulos; e os termos restantes permanecerão em vigor.
					O Desenvolvedor não estará renunciando a nenhum de seus direitos sob
					este Contrato se atrasar o exercício ou deixar de exercê-los. Somos
					contratantes independentes. Este Contrato não cria qualquer tipo de
					agência, parceria ou joint venture.
				</p>
				<p>
					10.5 Você não poderá ceder este Contrato sem o consentimento por
					escrito do Desenvolvedor, sendo que tal cessão poderá ser anulada pelo
					Desenvolvedor; No entanto, o Desenvolvedor poderá ceder este Contrato
					sem aviso prévio ou seu consentimento.
				</p>
				<p>
					10.6 Você pode entrar em contato com o Desenvolvedor através do
					endereço de email: contato@brajan.com.br
				</p>
			</div>
		</section>
	);
}

export default GestorPosLicenseAgreement;
